import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { Feedback } from '../../../core/services/satisfaction.service';
import { TimezoneService } from '../../../core/services/timezone.service';
import { formatInTimeZone } from 'date-fns-tz';

@Component({
  selector: 'app-call-history-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslatePipe],
  templateUrl: './call-history-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./call-history-modal.component.scss']
})
export class CallHistoryModalComponent implements OnChanges {
  private timezone = inject(TimezoneService);

  @Input() show = false;
  @Input() feedback: Feedback | null = null;
  @Output() close = new EventEmitter<void>();
  @Output() updateContent = new EventEmitter<{feedbackId: string, content: string}>();

  isEditing = false;
  editedContent = '';

  ngOnChanges(changes: SimpleChanges) {
    if (changes['show']) {
      document.body.style.overflow = this.show ? 'hidden' : '';
      if (this.show) {
        this.isEditing = false;
      }
    }
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const formatted = formatInTimeZone(date, this.timezone.getEstablishmentTimezone(), 'dd/MM/yyyy HH:mm');
    return `${formatted}${this.timezone.getTimezoneHint(date)}`;
  }

  onClose() {
    this.isEditing = false;
    this.close.emit();
  }

  toggleEdit() {
    this.isEditing = true;
    this.editedContent = this.feedback?.reply_content || '';
  }

  cancelEdit() {
    this.isEditing = false;
    this.editedContent = '';
  }

  saveEdit() {
    if (this.feedback && this.editedContent.trim()) {
      this.updateContent.emit({
        feedbackId: this.feedback.feedback_id,
        content: this.editedContent
      });
      if (this.feedback.reply_content !== undefined) {
        this.feedback.reply_content = this.editedContent;
      }
      this.isEditing = false;
    }
  }
}
